import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading vuex modules
 * -----------------------------------------------------------------------------------------------------------
 */
import account from '@/components/account/store'
import schools from '@/components/schools/store'
import classUsers from '@/components/class-users/store'
import classPros from '@/components/class-pros/store'
import blogs from '@/components/blogs/store'
import courses from '@/components/courses/store'
import comments from '@/components/comments/store'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    account,
    schools,
    classUsers,
    classPros,
    blogs,
    courses,
    comments
  },
  state: {
    loading: false,
    breadcrumb: [
      { name: 'home-index', text: 'Trang chủ' }
    ],
    path: ''
  },
  getters: {
    loading: (state) => state.loading,
    breadcrumb: (state) => state.breadcrumb,
    path: (state) => state.path
  },
  actions: {
    setBreadcrumb ({commit, dispatch}, breadcrumb) {
      commit('setBreadcrumb', breadcrumb)
    },
    setPath ({commit, dispatch}, path) {
      commit('setPath', path)
    }
  },
  mutations: {
    setBreadcrumb (state, setBreadcrumb) {
      state.breadcrumb = setBreadcrumb
    },
    setPath (state, path) {
      state.path = path
    }
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})



// WEBPACK FOOTER //
// ./src/store/index.js